import { DataTable } from "../../../data-table.interface";
import { Consolidated } from "../../../../../../core/models/picking/consolidated.model";

export const selectedDispatchesForNewLot: DataTable = {
  hasDisabledInput: (): boolean => false,
  columns: [
    {
      title: 'N° de despacho',
      name: 'serialNumber',
      type: 'string',
      class: 'number-order-consolidated',
      sortServer: true,
      value: (element: Consolidated) =>
        element.serialNumber ? element.serialNumber : ''
    },
    {
      title: 'Estado',
      name: 'stateOrderDispatch.name',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.state
    },
    {
      title: 'Fecha de despacho',
      name: 'dateDispatch',
      type: 'string',
      class: 'center',
      sortServer: true,
      value: (element: Consolidated) => element.retirementDate
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeCode',
      type: 'string',
      editable: false,
      checkAll: false,
      sortServer: true,
      value: (element: Consolidated) => element.dispatchTypeCode
    }
  ],
};
